























import { Component, Vue } from "vue-property-decorator";
import { brand, socialMedia } from "@/config";
import moment from "moment";

@Component
export default class AppFooter extends Vue {
  get year() {
    return moment().format("Y");
  }

  get version() {
    return process.env.VUE_APP_GIT_VERSION;
  }

  get versionLink() {
    return `https://github.com/ArkEcosystem/explorer/commit/${process.env.VUE_APP_GIT_VERSION}`;
  }

  get date() {
    return process.env.VUE_APP_GIT_DATE;
  }

  get brandData() {
    return brand;
  }

  get socialMediaData() {
    return socialMedia;
  }
}
